import React from 'react';

const QuotationPreview = ({ pdfUrl, onBack, onDownload, formData }) => {
    // Calculate total amount
    const totalAmount = formData.options.reduce((sum, opt) => sum + (parseFloat(opt.amount) || 0), 0);

    return (
        <div className="preview-container">
            <div className="preview-header">
                <h2 className="mb-0 text-white">
                    <i className="fa fa-file-pdf me-2"></i>
                    Quotation Preview
                </h2>
                <div className="preview-actions">
                    <button onClick={onBack} className="btn btn-secondary">
                        <i className="fa fa-arrow-left me-2"></i>
                        Edit Form
                    </button>
                    <button onClick={onDownload} className="btn btn-success">
                        <i className="fa fa-download me-2"></i>
                        Download PDF
                    </button>
                </div>
            </div>

            <div className="preview-summary">
                {/* Company Information Display */}
                <div className="company-info-box mb-4 p-3 bg-light rounded">
                    <h4 className="text-primary mb-3">
                        <i className="fa fa-building me-2"></i>
                        Company Details
                    </h4>
                    <div className="row">
                        <div className="col-md-12">
                            <p className="mb-1"><strong>PRIMEDALE TOURS & TRAVEL</strong></p>
                            <p className="mb-1">📞 +254745715136</p>
                            <p className="mb-1">📍 VIEWPARK TOWERS, UTALII LANE</p>
                            <p className="mb-1">✉️ info@primedaletours.com</p>
                            <p className="mb-1">🌐 www.primedaletours.com</p>
                            <p className="mb-0 text-primary fst-italic">✨ Precision in Every Journey</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <h4 className="text-primary mb-3">Quotation Summary</h4>
                        <div className="summary-details">
                            <p>
                                <strong className="text-dark">Quote Number:</strong>
                                <span className="text-muted ms-2">{formData.quoteNo || 'N/A'}</span>
                            </p>
                            <p>
                                <strong className="text-dark">Date:</strong>
                                <span className="text-muted ms-2">{formData.date || 'N/A'}</span>
                            </p>
                            <p>
                                <strong className="text-dark">Client:</strong>
                                <span className="text-muted ms-2">{formData.client || 'N/A'}</span>
                            </p>
                            <p>
                                <strong className="text-dark">Phone:</strong>
                                <span className="text-muted ms-2">{formData.phone || 'N/A'}</span>
                            </p>
                            <p>
                                <strong className="text-dark">Location:</strong>
                                <span className="text-muted ms-2">{formData.location || 'N/A'}</span>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h4 className="text-primary mb-3">Summary</h4>
                        <div className="summary-details">
                            <p>
                                <strong className="text-dark">Total Options:</strong>
                                <span className="text-muted ms-2">{formData.options.filter(opt => opt.name).length}</span>
                            </p>
                            <p>
                                <strong className="text-dark">Inclusives:</strong>
                                <span className="text-muted ms-2">{formData.inclusives.filter(i => i).length} items</span>
                            </p>
                            <p>
                                <strong className="text-dark">Exclusives:</strong>
                                <span className="text-muted ms-2">{formData.exclusives.filter(e => e).length} items</span>
                            </p>
                            <p>
                                <strong className="text-dark">Total Amount:</strong>
                                <span className="text-success fw-bold ms-2">KES {totalAmount.toLocaleString()}</span>
                            </p>
                        </div>
                    </div>
                </div>

                {formData.options.filter(opt => opt.name).length > 0 && (
                    <div className="options-summary mt-4">
                        <h5 className="text-primary mb-3">
                            <i className="fa fa-list me-2"></i>
                            Selected Options:
                        </h5>
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>SL</th>
                                        <th>Package Name</th>
                                        <th>Amount (KES)</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.options.filter(opt => opt.name).map((opt, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{opt.sl}</td>
                                            <td><strong>{opt.name}</strong></td>
                                            <td>{parseFloat(opt.amount).toLocaleString()}</td>
                                            <td>{opt.description || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="table-light">
                                    <tr>
                                        <td colSpan="2" className="text-end fw-bold">Total:</td>
                                        <td className="fw-bold text-success">KES {totalAmount.toLocaleString()}</td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {pdfUrl && (
                <div className="pdf-viewer">
                    <iframe
                        src={pdfUrl}
                        title="PDF Preview"
                        className="pdf-preview"
                    />
                </div>
            )}
        </div>
    );
};

export default QuotationPreview;